var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('Space'),_c('Button',{attrs:{"icon":"add","label":_vm.$t('Add Alert')},on:{"click":_vm.openModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }